import SkeletonChats from 'components/skeleton/SkeletonChats';
import useLoadPatientHistory from 'hooks/useLoadPatientHistory';
import useSelectConversations from 'hooks/useSelectConversations';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ChatsList from '../components/chats/ChatsList';
import ConversationTopBar from '../components/chats/ConversationTopBar';

export default function PatientConversationsHistory() {
  const { t } = useTranslation();
  const { conversationMetadata } = useSelectConversations();
  const navigate = useNavigate();

  // Reuse the cached patient history that ConversationPage already started loading
  // when this conversation was opened. Mounting the hook here is what guarantees the
  // page works on a deep link / hard reload (no prior ConversationPage mount); on the
  // common path where the user just clicked the "Historique" button, the cache is
  // already warm and no extra request is sent.
  const { history, loading } = useLoadPatientHistory(conversationMetadata?.conversation.patient.id ?? '');

  const isLoading = loading && history.length === 0;

  return (
    <div className="flex h-full w-full">
      <div className="flex h-full w-full flex-col border-r border-border sm:w-1/3 lg:w-1/4">
        <ConversationTopBar
          showBackButton
          avatar={null}
          name={t('chats.subtitle.history')}
          caregiverId={undefined}
          onBackButtonClick={() => navigate(-1)}
        />
        {isLoading ? (
          <SkeletonChats numberOfItems={3} />
        ) : (
          <ChatsList conversations={history} title={null} readOnlyConvs />
        )}
      </div>
    </div>
  );
}
